
import { getField, updateField } from 'vuex-map-fields';
import NotificationService from '@/services/notification.service';
import dayjs from 'dayjs';
import i18n from '@/locales/i18n'

let duration = require('dayjs/plugin/duration');
dayjs.extend(duration);

const SET_NOTIFICATION_LIST = 'SET_NOTIFICATION_LIST';
const SET_NOT_READED_NOTIFICATION_COUNT = 'SET_NOT_READED_NOTIFICATION_COUNT';
const FIRST_INDEX = 0
const SECOND_INDEX = 1

function hourAgoCallback(created_at) {
	return dayjs.duration(dayjs(new Date()).diff(dayjs(created_at)))
}

function customNotification(item) {
	let customData = {...item}
	customData["message"] = item.message.split('and')[FIRST_INDEX] ? item.message.split('and')[FIRST_INDEX].trim() : '';
	customData["reason"] = item.message.split('and reason is:')[SECOND_INDEX] ? `Reason: ${item.message.split('and reason is:')[SECOND_INDEX].trim()}` : '';
	let timeAgo = '1 minute ago'
	let timeDiffInMilSecs = hourAgoCallback(item.created_at)
	if (timeDiffInMilSecs.asDays() >= 1) {
		timeAgo = dayjs(item.created_at).format('YYYY-MM-DD HH:mm:ss')
	} else if (timeDiffInMilSecs.asHours() >= 2) {
		timeAgo = Math.floor(timeDiffInMilSecs.asHours()) + ' hours ago'
	}
	else if (timeDiffInMilSecs.asHours() < 2 && timeDiffInMilSecs.asHours() >= 1) { 
		timeAgo = Math.floor(timeDiffInMilSecs.asHours()) + ' hour ago'
	}
	else if (timeDiffInMilSecs.asMinutes() >= 2) { 
		timeAgo = Math.floor(timeDiffInMilSecs.asMinutes()) + ' minutes ago'
	}
	customData["diff"] = timeAgo

	return customData
}

export default {
	namespaced: true,
	state: {
		notReadedNotificationCount: 0,
		notificationList: [],
	},

	actions: {
		async retrieveAllNotification({ commit, state, dispatch }, payload) { 
			let response = await NotificationService.getAllNotification({
				username: payload.username,
				page: payload.page ? payload.page : 1,
				limit: payload.limit ? payload.limit : 20,
			});
			let notifications = response.data.notifications;
			
			let customNotificationList = notifications.map((item) => {
				return {
					...customNotification(item),
				};
			});
			commit(SET_NOTIFICATION_LIST, customNotificationList);

			commit(SET_NOT_READED_NOTIFICATION_COUNT, response.data.not_readed_notification_count);
			return customNotificationList;
		},
		async updateNotification({ commit, state, dispatch }, payload) { 
			await NotificationService.updateNotification({
				username: payload.username,
			});
			dispatch('retrieveAllNotification', { username: payload.username });
		}
	},
	mutations: {
		updateField,
		
		SET_NOTIFICATION_LIST(state, payload) {
			state.notificationList = payload;
		},
		SET_NOT_READED_NOTIFICATION_COUNT(state, payload) {
			state.notReadedNotificationCount = payload;
		}
	},
	getters: {
		getField,
	},
	modules: {
	
	},
};
